import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Armchair } from "lucide-react";
import { B2bStatsCardProps } from "@/services/organizationsApi";

export function B2bSeatsCard({ stats, loading, error }: B2bStatsCardProps) {
  const s = stats?.seats;
  const occupancy =
    s && s.total_purchased_seats > 0
      ? Math.round((s.total_occupied_seats / s.total_purchased_seats) * 100)
      : 0;
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Sièges</CardTitle>
        <Armchair className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        {loading && (
          <div className="text-sm text-muted-foreground">Chargement...</div>
        )}
        {error && <div className="text-sm text-red-600">{error}</div>}
        {!loading && !error && s && (
          <>
            <div className="text-2xl font-bold">
              {s.total_occupied_seats}/{s.total_purchased_seats}
            </div>
            <div className="mt-1 text-xs text-muted-foreground">
              {occupancy}% d'occupation
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}
